import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { selectMenuZIndex } from '../../../../styles/global';

type Props = {
  label: string;
  value?: string;
  onChange: (value: string) => void;
  disabled: boolean;
  withTime?: boolean;
};

const OrderFilterDateInput = ({ label, value, onChange, disabled, withTime = false }: Props) => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const locale = i18n.language?.startsWith('pt') ? 'pt-br' : 'en';
  const placeholder = locale === 'pt-br' ? 'DD/MM/AAAA' : 'DD/MM/YYYY';
  const Picker = withTime ? DateTimePicker : DatePicker;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      <Picker
        value={value ? dayjs(value) : null}
        onChange={(date) => onChange(date?.isValid() ? date.format(withTime ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD') : '')}
        inputFormat={withTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'}
        disabled={disabled}
        PopperProps={{ sx: { zIndex: selectMenuZIndex } }}
        DialogProps={{ sx: { zIndex: selectMenuZIndex } }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            size="small"
            inputProps={{
              ...params.inputProps,
              'aria-label': label,
              placeholder: withTime ? `${placeholder} HH:mm` : placeholder,
            }}
            sx={{
              '& .MuiInputBase-root': { backgroundColor: theme.colors.surface, color: theme.colors.onSurface },
              '& .MuiInputBase-input': { padding: '5px', fontSize: '0.9rem' },
              '& .MuiSvgIcon-root': { color: theme.colors.onSurface },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default OrderFilterDateInput;
